export default __webpack_public_path__ + "static/media/BMW_Group_White.6b809d38.svg";